import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import AuthService from '../services/auth.service';

const PrivateRoute = ({ ...props }) => {
    //const user = AuthService.getCurrentUser();
    return props.currentUser ? <Route { ...props } /> : <Redirect to="/" />;
}

export default PrivateRoute;